<template>
  <v-data-table :headers="headers" :search="search" :items-per-page="5" :items="withdrawals">
    <template v-slot:item.sl="{ index, item }">
      {{ index + 1 }}
    </template>
    <template v-slot:item.payment_system="{ index, item }">
      {{ item.payment_system?.method_name }}
    </template>
    <template v-slot:item.email="{ index, item }">
      {{ item.account?.email }}
    </template>
    <template v-slot:item.created_at="{ index, item }">
      {{ formatMySQLDate(item?.created_at) }}
    </template>
    <template v-slot:item.account="{ item }">
      <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item.account?.id}`">
        {{ item.account?.fullname }}
      </router-link>
    </template>
    <template v-slot:item.status="{ item }">
      <div class="d-flex align-items-center justify-center">
        <div>
          <v-icon small :class="verifyIcon(item.status)"></v-icon>
          {{
            item.status === 0
              ? "Pending"
              : item.status === 1
                ? "Approved"
                : item.status === 2
                  ? "Rejected"
                  : null
          }}
        </div>
      </div>
    </template>

    <template v-slot:item.DetailsView="{ item }">
      <v-dialog transition="scale-transition" origin="center center" max-width="985px" v-model="detailsDialog[item?.id]"
        content-class="deposit-modal">
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex align-items-center">
            <div v-bind="attrs" v-on="on">
              <v-icon color="#039de9" small @click="handleFile(item?.payment_slip)">
                mdi-eye-outline
              </v-icon>
            </div>
          </div>
        </template>

        <template>
          <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
            <v-btn class="close-btn" icon dark @click="handleClose(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-card-title>
              <div class="image-details">
                <v-img src="@/assets/bank-transfer.png"></v-img>
                <h3>{{ item?.payment_system?.method_name }}</h3>
              </div>
              <div class="content-details">
                <h3>Withdrawal:</h3>
                <span>${{ item?.amount }}</span>
              </div>
            </v-card-title>
            <v-card-text>
              <div v-if="selectedFile">
                <iframe :src="item?.payment_slip" width="100%" height="400px" frameborder="0"></iframe>
              </div>
              <div v-else>
                <p>
                  No document preview available for this
                  deposit.
                </p>
              </div>
            </v-card-text>
            <v-card-subtitle>
              <div class="download-icon cursor-pointer" @click="downloadFile(item?.payment_slip)">
                <p>Download</p>
                <v-icon small slot="append" color="#039de9">
                  mdi-tray-arrow-down
                </v-icon>
              </div>
              <div class="tab-details cursor-pointer" @click="openInNewTab(item?.payment_slip)">
                <p>Open In New Tab</p>
                <v-icon small slot="append" color="#039de9">mdi-eye</v-icon>
              </div>
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <h1>All Information</h1>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Name</legend>
                    <v-text-field readonly :value="item?.account.fname+' '+item?.account.lname" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Email</legend>
                    <v-text-field readonly :value="item?.account.email" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Account No</legend>
                    <v-text-field readonly :value="item?.trading_account_no" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Transaction Method</legend>
                    <v-text-field readonly :value="item?.payment_system?.method_name
                      " single-line solo hide-details class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Transaction ID</legend>
                    <v-text-field readonly :value="item?.transaction_id || 'N/A'
                      " single-line solo hide-details class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Amount</legend>
                    <v-text-field readonly :value="item?.amount" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Trx. Fee</legend>
                    <v-text-field readonly :value="item?.trx_fee" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Net Amount</legend>
                    <v-text-field readonly :value="item?.net_amount" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Reference No.</legend>
                    <v-text-field readonly :value="item?.reference" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Time</legend>
                    <v-text-field readonly :value="item?.created_at" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Verification Image</legend>
                    <v-text-field readonly :value="item?.payment_slip" single-line solo hide-details
                      class="custom-select">
                      <v-icon small slot="append" color="#039de9" @click="
                        downloadFile(item?.payment_slip)
                        ">
                        mdi-tray-arrow-down
                      </v-icon></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <fieldset>
                    <legend>Status</legend>
                    <v-text-field readonly :value="item?.status === 0
                      ? 'Pending'
                      : item?.status === 1
                        ? 'Approved'
                        : 'Rejected'
                      " single-line solo hide-details class="custom-select">
                      <v-icon small slot="prepend" color="#FFC020">
                        mdi-star-outline
                      </v-icon></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="12">
                  <fieldset>
                    <legend>Remarks</legend>
                    <v-text-field readonly :value="item?.remarks" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
              </v-row>

              <v-row v-if="isItOpen(item) && $canRoute('withdraw-partner-tab') === 1">
                <v-col cols="6">
                  <div class="button-wrapper">
                    <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                      color="greenMain" :disabled="item?.status === 1" @click="handleWithdrawApprove(item)">
                      {{
                        item?.status === 1
                          ? "Approved"
                          : "Approve"
                      }}
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="button-wrapper">
                    <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4" color="#FF567F"
                      :disabled="item?.status === 1" @click="handleOpenRejected()">
                      Rejected
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="
                item?.status === 2 ||
                showRejectionCauseSection
              ">
                <v-col cols="12">
                  <h2>Rejection Cause</h2>
                </v-col>
                <v-col cols="12" v-if="item?.status !== 2">
                  <fieldset>
                    <legend>Reason</legend>
                    <v-select v-model="selectedReason" solo :items="slots5" append-icon="mdi-chevron-down"
                      label="Click to select" class="custom-select" hide-details></v-select>
                  </fieldset>
                </v-col>
                <v-col cols="12" v-if="
                  item?.status === 2 ||
                  selectedReason === 'Other'
                ">
                  <fieldset>
                    <legend>
                      {{
                        item?.status === 2
                          ? "Reason"
                          : "Write Your Reason"
                      }}
                    </legend>
                    <v-text-field :disabled="item?.status === 2" v-model="reason" single-line :label="item?.status === 2
                      ? item?.reason
                      : 'Write here'
                      " solo hide-details class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
                <v-col cols="6" v-if="item?.status !== 2">
                  <div class="button-wrapper">
                    <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4" color="#FF567F"
                      @click="
                        handleWithdrawConfrimRejected(item)
                        ">
                      Confirm Reject
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="6" v-if="item?.status !== 2">
                  <div class="button-wrapper">
                    <v-btn small tile elevation="0" block outlined class="ma-0 text-capitalize btn-account py-4"
                      @click="handleCloseRejected()">
                      Cancel
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>
    </template>
  </v-data-table>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { PARTNERLIST__ACTIONS, PARTNERWITHDRAW__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    withdrawals: {
      type: Array
    },
    search: {
      type: String
    },
  },
  data() {
    return {
      modal: false,
      dialog: false,
      embeddedUrl: "",
      depositModal: {},
      reason: null,
      remarks: null,
      showButtons: true,
      selectedReason: null,
      detailsDialog: {},
      selectedFile: null,
      showRejectionCauseSection: false,
      slots5: [
        "Deposit and withdrawal method must be same",
        "Not enough balance",
        "Can't transfer funds to third party accounts",
        "Any fraudulent activity we must suspend the principal account until investigation of compliance",
        "Other",
      ],
      VerificationImage: "4334jue8d3f5r43r42r4484599gy676....pdf",
      headers: [
        { text: "SR No.", value: "sl" },
        { text: "Time", value: "created_at" },
        { text: "Name", value: "account" },
        { text: "Email", value: "email" },
        { text: "Amount", value: "amount" },
        { text: "Trx. Method", value: "payment_system" },
        { text: "Status", value: "status" },
        { text: "Details", value: "DetailsView" },
      ],
    };
  },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),
    isItOpen() {
      return function (item) {
        return item?.status !== 2;
      };
    },
  },
  methods: {
        //formatMySQLDate is needed for timeformat
    formatMySQLDate,
    ...mapActions("partnerwithdraw", [
      PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAW,
      PARTNERWITHDRAW__ACTIONS.CHANGESTATUS,
      PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW,
    ]),

    ...mapActions("partnerlist", [PARTNERLIST__ACTIONS.WITHDRAWALS]),

    handleFile(item) {
      this.selectedFile = item;
    },

    handleClose(item) {
      this.$set(this.detailsDialog, item?.id, false);
    },

    downloadFile(fileUrl) {
      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = true;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    openInNewTab(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    async handleWithdrawApprove(item) {
      let parameter = {
        id: item?.id,
        status: 1,
        remarks: this.remarks,
      };
      await this[PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](parameter);
      await this[PARTNERLIST__ACTIONS.WITHDRAWALS]({ partner_id: this.$route.query.id });
    },

    handleOpenRejected() {
      this.showRejectionCauseSection = true;
      this.showButtons = false;
    },

    handleCloseRejected() {
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
    },

    async handleWithdrawConfrimRejected(item) {
      let parameter = {
        id: item?.id,
        status: 2,
        reason: this.reason || this.selectedReason || "N/A",
      };
      await this[PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](parameter);
      await this[PARTNERLIST__ACTIONS.WITHDRAWALS]({ partner_id: this.$route.query.id });
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
      this.reason = null;
    },

    verifyIcon(status) {
      if (status === 1) return "mdi mdi-check text--green mr-1";
      else if (status === 2)
        return "mdi mdi-window-close red--text mr-1";
      else return "mdi mdi-refresh mr-1 yellow--text";
    },
  },
  
  async created() {
    this.selectedSlot = "Approved";
  },
};
</script>